import { memo } from 'react';

import { Icon } from '@gitbook/spine-icons';
import { Alert, Link } from '@gitbook/spine-react';
import { isHttpUrl } from '@gitbook/util-url';

import { usePageImportSourceURL } from '../../../../Components';
import { useSpaceContext } from '../../context';

/**
 * Alert displayed when a page is imported from an external source.
 * Only displayed for HTTP(S) sources.
 */
export const PageImportHeaderAlert = memo(function PageImportHeaderAlert(props: {
    pageId: string;
}) {
    const context = useSpaceContext();

    // Only show the alert if we are in a change request context
    // if the import is run from a unlocked space, we don't show it because it would be here forever.
    if (!context.changeRequest) {
        return null;
    }

    return (
        <PageImportChangeRequestAlert
            spaceId={context.space.id}
            changeRequestId={context.changeRequest.id}
            pageId={props.pageId}
        />
    );
});

function PageImportChangeRequestAlert(props: {
    spaceId: string;
    changeRequestId: string;
    pageId: string;
}) {
    const sourceURL = usePageImportSourceURL({
        target: { space: props.spaceId, changeRequest: props.changeRequestId },
        pageId: props.pageId,
    });

    // Only show the alert for HTTP(S) sources.
    if (!sourceURL || !isHttpUrl(sourceURL)) {
        return null;
    }

    return (
        <Alert
            kind="default"
            size="xsmall"
            className="mb-4"
            icon={Icon.Download}
            details={
                <>
                    This page has been imported from{' '}
                    <Link href={sourceURL} target="_blank">
                        {sourceURL}
                    </Link>
                </>
            }
        />
    );
}
